import { render } from "./form-color.vue?vue&type=template&id=6f7dd160"
import script from "./form-color.vue?vue&type=script&lang=js"
export * from "./form-color.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__